import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Ng2PaginationModule} from 'ng2-pagination';

import {ModalConfirmationModule} from 'shared/modals/modal-confirmation/modal-confirmation.module';
import {PaginationBootstrapModule} from 'shared/pagination-bootstrap/pagination-bootstrap.module';
import {SearchBarModule} from 'shared/search-bar/search-bar.module';
import {ThesisOverviewRepository} from './repositories/thesis-overview.repository';
import {ThesisOverviewService} from './services/thesis-overview.service';
import {ThesisOverviewRoutingModule} from './thesis-overview-routing.module';
import {ThesisOverviewComponent} from './thesis-overview.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    Ng2PaginationModule,
    ThesisOverviewRoutingModule,
    PaginationBootstrapModule,
    ModalConfirmationModule,
    SearchBarModule,
  ],
  declarations: [
    ThesisOverviewComponent,
  ],
  providers: [
    ThesisOverviewService,
    ThesisOverviewRepository,
  ],
})

export class ThesisOverviewModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/thesis/thesis-overview/thesis-overview.module.ts